module.exports = __webpack_public_path__ + "HelveticaLightOblique.d0a3884dd21cebdbbecc.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-netsul/src/app/@theme/fontes/Helvetica/HelveticaLightOblique.svg
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaLightOblique.svg
// module chunks = styles